import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../../services/baseQuery";

const baseApi = createApi({
    reducerPath: "api",
    baseQuery: dynamicBaseQuery,
    tagTypes: ["OpenTickets", "MyTickets", "Profile", "PrioritySets", "PriorityList", "Statuses", "Teams", "Queues", "Clients", "Projects", "UserSetting",
        "Tenant", "HostConfig", "TicketsList", "User", "TenantLoginConfig"
    ],
    endpoints: () => ({}),
});

export { baseApi };